// extracted by mini-css-extract-plugin
export var avatarContainer = "_5q-1";
export var largeAvatarContainer = "_5q-2";
export var smallAvatarContainer = "_5q-0";